__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "data-ventures-app-shell";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@aurora/federation", "2.3.3", function() { return function() { return __webpack_require__(27892); }; }, 1);
			register("@aurora/subapp-react", "2.0.6", function() { return function() { return __webpack_require__(81860); }; }, 1);
			register("@livingdesign/icons", "0.4.53", function() { return function() { return __webpack_require__(7140); }; }, 1);
			register("@livingdesign/icons", "1.8.1", function() { return function() { return __webpack_require__(33838); }; }, 1);
			register("@opentelemetry/api", "1.9.1", function() { return __webpack_require__.e(194).then(function() { return function() { return __webpack_require__(7838); }; }); });
			register("@walmart-dataventures/integrated-components", "1.36.0", function() { return Promise.all([__webpack_require__.e(805), __webpack_require__.e(206), __webpack_require__.e(44)]).then(function() { return function() { return __webpack_require__(90230); }; }); });
			register("@walmart-dataventures/shared-components", "10.0.0", function() { return Promise.all([__webpack_require__.e(194), __webpack_require__.e(577), __webpack_require__.e(237)]).then(function() { return function() { return __webpack_require__(24481); }; }); });
			register("@walmart-web/livingdesign-components", "1.0.38", function() { return function() { return __webpack_require__(62798); }; }, 1);
			register("@walmart/marty-ui-core", "1.3.949", function() { return function() { return __webpack_require__(50923); }; }, 1);
			register("react-dom", "18.3.1", function() { return function() { return __webpack_require__(78325); }; }, 1);
			register("react-router-dom", "6.30.2", function() { return function() { return __webpack_require__(46284); }; }, 1);
			register("react", "18.3.1", function() { return function() { return __webpack_require__(63696); }; }, 1);
			register("styled-components", "6.5.3", function() { return function() { return __webpack_require__(47227); }; }, 1);
			register("zone.js", "0.16.3", function() { return __webpack_require__.e(964).then(function() { return function() { return __webpack_require__(78964); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};